// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"_3-L4p","location-container--header":"nmreS","body":"lasL7","body-art":"NB5vn","rc-tabs-bar":"QXgWP","rc-tabs-tab":"XDymA","rc-tabs-tab-active":"ZykR6"};